/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvoiceStatus } from './InvoiceStatus';
import {
    InvoiceStatusFromJSON,
    InvoiceStatusFromJSONTyped,
    InvoiceStatusToJSON,
    InvoiceStatusToJSONTyped,
} from './InvoiceStatus';

/**
 * 
 * @export
 * @interface GetFacilityInvoiceStatuses200Response
 */
export interface GetFacilityInvoiceStatuses200Response {
    /**
     * 
     */
    data?: Array<InvoiceStatus>;
}

/**
 * Check if a given object implements the GetFacilityInvoiceStatuses200Response interface.
 */
export function instanceOfGetFacilityInvoiceStatuses200Response(value: object): value is GetFacilityInvoiceStatuses200Response {
    return true;
}

export function GetFacilityInvoiceStatuses200ResponseFromJSON(json: any): GetFacilityInvoiceStatuses200Response {
    return GetFacilityInvoiceStatuses200ResponseFromJSONTyped(json, false);
}

export function GetFacilityInvoiceStatuses200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFacilityInvoiceStatuses200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(InvoiceStatusFromJSON)),
    };
}

export function GetFacilityInvoiceStatuses200ResponseToJSON(json: any): GetFacilityInvoiceStatuses200Response {
    return GetFacilityInvoiceStatuses200ResponseToJSONTyped(json, false);
}

export function GetFacilityInvoiceStatuses200ResponseToJSONTyped(value?: GetFacilityInvoiceStatuses200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(InvoiceStatusToJSON)),
    };
}

